import axios from "axios";
import database from './db';

const actions =  {
    async updateItemsIndex(context, payload) {
        if (context.state.sync.fetching_items) return;

        context.commit('setFetchingItems', true);
        try {
            let response = await axios.get(`https://api.torn.com/torn/?selections=items&key=${context.state.auth.key}`);
            let item_ids = Object.keys(response.data.items);
            let items = item_ids.map(id => {
                let item = response.data.items[id];
                item.id = id;
                return item;
            });
            for (let item of items) {
                let existing_items = await database.items.where('id').equals(item.id).toArray();
                if (existing_items.length) {
                    let existing_item = existing_items[0];
                    let market_history = existing_item.market_history || [];
                    let updated_item = {
                        ...item,
                        id: parseInt(item.id),
                        market_history: [
                            ...market_history,
                            {
                                timestamp: new Date().getTime(),
                                value: item.market_value,
                            }
                        ]
                    };

                    await database.items.update('id', updated_item);
                } else {
                    await database.items.add(item);
                }

            }

            context.commit('addItems', items);
            context.commit('setFetchingItems', false);
            context.commit('setItemsLastIndexed', new Date().getTime());
        } catch (error) {
            console.log("Error fetching items", error);
            context.commit('setFetchingItems', false);
        }
    },

    async loadItemsIndex(context) {
        let items = await database.items.orderBy('id').toArray();
        context.commit('addItems', items);
    }
};

const mutations = {
    setFetchingItems(state, value) {
        state.sync.fetching_items = value;
    },

    setItemsLastIndexed(state, value) {
        state.sync.items_last_indexed = value;
        window.localStorage.items_last_indexed = value;
    },

    addItems(state, items) {
        items.forEach(item => {
            state.items[item.id] = item;
        });
    },
}

export default {
    actions,
    mutations
};